export default "__VITE_ASSET__ee032b35__"